import { NgModule } from '@angular/core';
import { LoggingService } from './logging.service';

@NgModule({
	providers: [LoggingService]
})
export class LoggingModule { }